export const footerItems = [
  {
    header: {
      en: 'Teams',
      es: 'Equipos',
    },
    items: [
      { label: 'Dallas Cowboys', url: '/dallas-cowboys' },
      { label: 'Kansas City Chiefs', url: '/kansas-city-chiefs' },
      { label: 'Chicago Bears', url: '/chicago-bears' },
      { label: 'Pittsburgh Steelers', url: '/pittsburgh-steelers' },
      { label: 'San Francisco 49ers', url: '/san-francisco-49ers' },
      { label: 'Georgia Bulldogs', url: '/georgia-bulldogs' },
      { label: 'LSU Tigers', url: '/lsu-tigers' },
      { label: 'Alabama Crimson Tide', url: '/alabama-crimson-tide' },
      { label: 'Michigan Wolverines', url: '/michigan-wolverines' },
      { label: 'Oregon Ducks', url: '/oregon-ducks' },
      { label: 'Ohio State Buckeyes', url: '/ohio-state-buckeyes' },
      { label: 'Florida Gators', url: '/florida-gators' },
    ],
  },
  {
    header: {
      en: 'Leagues',
      es: 'Ligas',
    },
    items: [
      { label: 'NFL', url: '/nfl' },
      { label: 'College Football', url: '/college-football' },
      { label: 'Soccer', url: '/soccer' },
      { label: 'MLB', url: '/mlb' },
      { label: 'Cricket', url: '/cricket' },
      { label: 'WNBA', url: '/wnba' },
      { label: 'College Basketball', url: '/college-basketball' },
      { label: 'NBA', url: '/nba' },
      { label: 'NHL', url: '/nhl' },
      { label: 'NASCAR', url: '/nascar' },
      { label: 'LaLiga', url: '/la/la-liga-on-espn-deportes/' },
      { label: 'BetPlay Dimayor', url: '/la/liga-betplay-dimayor/' },
    ],
  },
  {
    header: {
      en: 'Networks',
      es: 'Canales',
    },
    items: [
      { label: 'NFL Network', url: '/nfl-network' },
      { label: 'FOX', url: '/live/preview/fox/' },
      { label: 'CBS', url: '/cbs' },
      { label: 'ESPN', url: '/espn' },
      { label: 'MLB.TV', url: '/mlb-tv' },
      // TEMPORARY NBC DISPUTE
      // { label: 'NBC', url: '/live/preview/nbc/' },
      { label: 'FS1', url: '/live/preview/fs1/' },
      { label: 'NHL Network', url: '/live/preview/nhl-network/' },
      { label: 'NFL RedZone', url: '/nfl-redzone-online' },
      { label: 'ABC', url: '/abc' },
      { label: 'MLB Network', url: '/live/preview/mlb-network/' },
      { label: 'FanDuel Sports Network', url: '/fanduel-sports-network' },
    ],
  },
  {
    header: {
      en: 'Compare',
      es: 'Comparar',
    },
    items: [
      { label: 'Fubo vs Sling', url: '/compare/fubo-vs-sling' },
      { label: 'Fubo vs Youtube TV', url: '/compare/fubo-vs-youtubetv' },
      { label: 'Fubo vs DirecTV', url: '/compare/fubo-vs-directv' },
      { label: 'Fubo vs Philo', url: '/compare/fubo-vs-philo' },
      { label: 'Fubo vs Cable', url: '/compare/fubo-vs-cable' },
      { label: 'Fubo vs Cox', url: '/compare/fubo-vs-cox' },
      { label: 'Fubo vs Verizon Fios', url: '/compare/fubo-vs-verizon-fios' },
      { label: 'Fubo vs Xfinity', url: '/compare/fubo-vs-xfinity' },
      { label: 'Fubo vs Spectrum', url: '/compare/fubo-vs-spectrum' },
      { label: 'Fubo vs Optimum', url: '/compare/fubo-vs-optimum' },
    ],
  },
]
